import apiRequest from './request'
import { ProfileTypes } from '../providers/SearchProfilesPage/types'
import { transformToQuery } from '../utils/query'

const basePath = process.env.NEXT_PUBLIC_BASIC_API_URL || ''

export const getQuickFacts = async ({
  keywordId,
  locale,
  profileSearchType,
  lat,
  lon,
  distance
}: {
  keywordId: number
  locale: string
  profileSearchType: (typeof ProfileTypes)[keyof typeof ProfileTypes]
  lat: string
  lon: string
  distance?: string
}) => {
  const query = transformToQuery({
    lat,
    lon,
    distance: distance === 'nolimit' ? null : distance
  })
  return apiRequest(`${basePath}/${locale}/search/${profileSearchType}/quick-facts/${keywordId}?${query}`).then((r) =>
    r.json()
  )
}

export const getTopQuestions = async ({
  keywordId,
  locale,
  locationId,
  profileSearchType,
  lat,
  lon,
  distance
}: {
  keywordId: number
  locale: string
  locationId: number
  profileSearchType: (typeof ProfileTypes)[keyof typeof ProfileTypes]
  lat: string
  lon: string
  distance?: string
}) => {
  const query = transformToQuery({
    lat,
    lon,
    distance: distance === 'nolimit' ? null : distance
  })
  return apiRequest(
    `${basePath}/${locale}/search/${profileSearchType}/top-questions/${keywordId}/${locationId}?${query}`
  ).then((r) => r.json())
}

export const getBookingInsurers = async ({ locale }: { locale: string }) => {
  return apiRequest(`${basePath.replace('webapi', '')}${locale}/api/listings/booking_insurers`).then((r) => r.json())
}
